import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import i18n from '../../../i18n';
import { Info } from '@wix/wix-vod-shared/components';
import { PRODUCTION_HOSTS } from '@wix/wix-vod-constants/env';

class VideoInfo extends React.Component {
  static propTypes = {
    posterUrl: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    publisher: PropTypes.string,
    durationStr: PropTypes.string,
    genre: PropTypes.string,
    cast: PropTypes.array,
    crew: PropTypes.array,
    isPlayerInFullScreen: PropTypes.bool,
  };

  getCrew(crew) {
    // eslint-disable-next-line arrow-parens
    return map(crew, (crewMember) => {
      const { role } = crewMember;

      if (!role) {
        return crewMember;
      }

      return {
        ...crewMember,
        role: i18n.t(`shared.crew.${role}`),
      };
    });
  }

  getGenre(genre) {
    return genre ? i18n.t(`shared.genres.${genre}`) : null;
  }

  getPublisher(publisher) {
    return publisher
      ? i18n.t('player.info-overlay.created-by', { author: publisher })
      : null;
  }

  render() {
    const {
      posterUrl,
      title,
      description,
      publisher,
      durationStr,
      genre,
      cast,
      crew,
      isPlayerInFullScreen,
    } = this.props;

    return (
      <Info
        title={title}
        description={description}
        posterUrl={posterUrl}
        durationStr={durationStr}
        publisher={this.getPublisher(publisher)}
        genre={this.getGenre(genre)}
        cast={cast}
        crew={this.getCrew(crew)}
        crewTitle={i18n.t('player.info-overlay.crew')}
        castTitle={i18n.t('player.info-overlay.cast')}
        isInFullScreen={isPlayerInFullScreen}
        imageHost={PRODUCTION_HOSTS.image}
      />
    );
  }
}

export default VideoInfo;
